import { render } from "./Text.vue?vue&type=template&id=d7e88d82&scoped=true"
const script = {}

import "./Text.vue?vue&type=style&index=0&id=d7e88d82&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7e88d82"]])

export default __exports__